module.exports = __webpack_public_path__ + "img/general-video.2eb6a38f.webp";